import React, { useState, useEffect, useRef } from "react";
import { Chart as ChartJS } from "chart.js";

import { convertEpochTimeToLocalTime } from "../../utils/helper";
import { useDispatch } from "react-redux";
import { MdExpandLess, MdExpandMore  } from "react-icons/md";
import { mapDuration } from "../../utils/helper";
import AreaChartWithCustomTooltip from "./Charts/AreaChartWithCustomTooltip";
import BsrChart from "./Charts/BsrChart";
import ReviewOfferChart from "./Charts/ReviewOfferChart";

const options = ["1 Week", "1 Month", "3 Months", "6 Months", "1 Year", "All" /*"Reset"*/];
const reviewChart = [
  { type: "Offers", color: "#a78bfa" },
  // { type: "Ratings", color: "#3c82f7" },
  { type: "Reviews Count", color: "#81e3d8" },
];

const chartTypes = [
  { type: "FBA", color: "#f97316" },
  { type: "FBM", color: "#0ea5e9" },
  { type: "Amazon", color: "#ba900b" },
  { type: "Buy Box", color: "#ec4899" },
];

const Chart = ({ data, ranksandprices, settingsData }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(true);
  const [chartType, setChartType] = useState("FBA");
  const [selectedOption, setSelectedOption] = useState(() =>
    options.includes(settingsData?.defaultValues?.charts_timeframe)
      ? settingsData.defaultValues.charts_timeframe
      : "1 Month"
  );
  const [labels, setLabels] = useState([]);
  const [dayCount, setDayCount] = useState(0);
  const [graphData, setGraphData] = useState([
    ranksandprices?.FBA_prices?.days_30,
    ranksandprices?.FBA_prices?.days_30,
    ranksandprices?.FBA_prices?.days_90,
  ]);

  const hoveredIndexRef = useRef(null);
  const graph1Ref = useRef(null);
  const graph2Ref = useRef(null);
  const graph3Ref = useRef(null);
  const randomRef = useRef(null);

  useEffect(() => {
    if(settingsData?.defaultValues?.charts_timeframe){
      const defaultOption = options.includes(settingsData.defaultValues.charts_timeframe)
        ? settingsData.defaultValues.charts_timeframe
        : selectedOption;
      setSelectedOption(defaultOption);
    }
  }, [settingsData])
  
  const plugin = {
    id: "corsair2",
    afterInit: (chart) => {
      chart.corsair = { x: 0, y: 0, draw: false };
    },
    afterEvent: (chart, evt) => {
      const {
        chartArea: { top, bottom, left, right },
      } = chart;
      const { x, y } = evt.event;

      if (x < left || x > right || y < top || y > bottom) {
        chart.corsair = { x, y, draw: false };
        chart.draw();
        // onLeave();
        return;
      }

      // const xIndex = chart.scales.x.getValueForPixel(x);
      // console.log('xIndex bsr:', xIndex, xIndex !== undefined);  // Add this line to debug the xIndex value

      // if (xIndex !== undefined) {
      // atHover(xIndex);
      // }

      // hoveredIndexRef.current = xIndex;
      // console.log('hoveredIndex afterevent:', hoveredIndex.current);
      chart.corsair = { x, y, draw: true };
      chart.draw();
    },
    afterDraw: (chart, _, opts) => {
      // console.log('afterdatasetsdraw chart.config.options.isBarChart:', chart.config.options.isBarChart);
      // console.log('afterdatasetsdraw chart.config.options.isAreaChart:', chart.config.options.isAreaChart);
      // console.log('afterdatasetsdraw corsair:', chart.corsair);
      if (chart._isDrawing) {
        // return;
      }

      let instances = ChartJS.instances;

      const {
        ctx,
        chartArea: { top, bottom },
        scales: { x },
      } = chart;
      const air = chart.corsair;
      if (!air) return;
      if (!air.x) return;
      if (air.x < 0) return;
      const xIndex = chart.scales.x?.getValueForPixel(air.x);

      if (!xIndex) return;

      if (xIndex < 0 || xIndex === null || !chart.data.labels || !x) return;
      if (xIndex >= chart.data.labels.length) return;

      const pixelX = x.getPixelForValue(chart.data.labels[xIndex]);

      if (typeof pixelX === "undefined") {
        console.log("pixelX is undefined");
        return;
      }

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(pixelX, bottom);
      ctx.lineTo(pixelX, top);
      ctx.lineWidth = opts.width || 2;
      ctx.setLineDash(opts.dash || []);
      ctx.strokeStyle = opts.color || "red";
      ctx.stroke();
      ctx.restore();

      let areaInstance, barInstance, reviewInstance;

      // Iterate over instances to identify the charts
      for (let key in instances) {
        if (instances[key].config._config.options.isAreaChart) {
          areaInstance = instances[key];
        } else if (instances[key].config._config.options.isBarChart) {
          barInstance = instances[key];
        } else if (instances[key].config._config.options.isReviewChart) {
          reviewInstance = instances[key];
        }
      }

      // Define a function to update an instance if necessary
      function updateInstance(instance, air) {
        if (instance && !instance.isUpdating) {
          instance.isUpdating = true;

          // Only update if the new position is different
          if (instance.corsair?.x !== air.x || instance.corsair?.y !== air.y) {
            instance.corsair = { x: air.x, y: air.y, draw: true };
            instance.tooltip.setActiveElements(
              [{ datasetIndex: 0, index: xIndex }],
              { x: air.x, y: air.y }
            );
            instance.update();
          }

          instance.isUpdating = false;
        }
      }

      // Update instances based on the chart type
      if (chart.config.options.isBarChart) {
        if (areaInstance) {
          updateInstance(areaInstance, air);
        }
        if (reviewInstance) {
          updateInstance(reviewInstance, air);
        }
      } else if (chart.config.options.isAreaChart) {
        if (barInstance) {
          updateInstance(barInstance, air);
        }
        if (reviewInstance) {
          updateInstance(reviewInstance, air);
        }
      } else if (chart.config.options.isReviewChart) {
        if (barInstance) {
          updateInstance(barInstance, air);
        }
        if (areaInstance) {
          updateInstance(areaInstance, air);
        }
      }
    },
  };

  ChartJS.register(plugin);

  const handleHover = (index) => {
    // hoveredIndexRef.current = index;
  };

  const handleLeave = () => {
    // setHoveredIndex(null);
  };

  const handleImageData = (imageData) => {
    const dataUrl = `data:image/png;base64,${imageData}`;
    // setChartImage(dataUrl);
  };

  const calculateDayDifference = (labels) => {
    if (!labels || labels.length === 0) return 0;

    const sortedLabels = [...labels].sort((a, b) => new Date(a) - new Date(b));
    const firstDate = new Date(sortedLabels[0]);
    const lastDate = new Date(sortedLabels[sortedLabels.length - 1]);
    const timeDiff = lastDate - firstDate;
    const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

    return dayDiff;
  };

  const getChartData = (option) => {
    const timePeriodMap = {
      "1 Week": "days_7",
      "1 Month": "days_30",
      "3 Months": "days_90",
      "6 Months": "days_180",
      "1 Year": "days_365",
      "All": "all_days"
    };

    const period = timePeriodMap[option ? option : selectedOption];
    if (!period) return [];

    const dataTypes = [
      'FBA_prices',
      'FBM_prices',
      'amazon_prices',
      'bsr_ranks',
      'bb_prices',
      'offers_count',
      'ratings',
      'reviews_count'
    ];

    return dataTypes.map(type => {
      return ranksandprices?.[type]?.[period]?.map(item => ({
        time: item.time,
        value: item.price || item?.value
      }));
    });
  };

  useEffect(() => {
    const getData = async () => {
      const data = getChartData(null);

      const [
        dataMain,
        dataFBM,
        dataAmazon,
        dataBsr,
        dataBb,
        dataOffers,
        dataRatings,
        dataReviews,
      ] = data || [];

      // Extract labels
      const extractLabels = (data) => data?.map((d) => d.time) || [];
      const labelsMain = extractLabels(dataMain);
      const labelsFBM = extractLabels(dataFBM);
      const labelsAmazon = extractLabels(dataAmazon);
      const labelsBsr = extractLabels(dataBsr);
      const labelsBb = extractLabels(dataBb);
      const labelsOffers = extractLabels(dataOffers);
      const labelsRatings = extractLabels(dataRatings);
      const labelsReviews = extractLabels(dataReviews);

      const mergedLabels = () => {
        let allLabels = [
          ...labelsMain,
          ...labelsFBM,
          ...labelsAmazon,
          ...labelsBb,
          ...labelsOffers,
          ...labelsRatings,
          ...labelsReviews,
        ];
        let uniqueLabels = [
          ...new Set(
            allLabels.map((label) => convertEpochTimeToLocalTime(label))
          ),
        ];
        uniqueLabels.sort((a, b) => new Date(a) - new Date(b));
        return uniqueLabels;
      };

      const labels = mergedLabels();
      setLabels(labels);
      setGraphData(data);
    };
    getData();
  }, [selectedOption, ranksandprices]);

  useEffect(() => {
    const getData = async () => {
      const data = getChartData("All");

      const [
        dataMain,
        dataFBM,
        dataAmazon,
        dataBsr,
        dataBb,
        dataOffers,
        dataRatings,
        dataReviews,
      ] = data || [];

      // Extract labels
      const extractLabels = (data) => data?.map((d) => d.time) || [];
      const labelsMain = extractLabels(dataMain);
      const labelsFBM = extractLabels(dataFBM);
      const labelsAmazon = extractLabels(dataAmazon);
      const labelsBsr = extractLabels(dataBsr);
      const labelsBb = extractLabels(dataBb);
      const labelsOffers = extractLabels(dataOffers);
      const labelsRatings = extractLabels(dataRatings);
      const labelsReviews = extractLabels(dataReviews);

      const mergedLabels = () => {
        let allLabels = [
          ...labelsMain,
          ...labelsFBM,
          ...labelsAmazon,
          ...labelsBb,
          ...labelsOffers,
          ...labelsRatings,
          ...labelsReviews,
        ];
        let uniqueLabels = [
          ...new Set(
            allLabels.map((label) => convertEpochTimeToLocalTime(label))
          ),
        ];
        uniqueLabels.sort((a, b) => new Date(a) - new Date(b));
        return uniqueLabels;
      };

      const labels = mergedLabels();
      const total_days = calculateDayDifference(labels);
      setDayCount(total_days);
      dispatch({
        type: "SET_TOTAL_DAYS",
        payload: total_days,
      })
    };
    getData();
  }, [ranksandprices]);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleZoomSync = (sourceChart) => {
    if (!sourceChart) return;

    const xScale = sourceChart.scales['x'];
    const newMin = xScale.min;
    const newMax = xScale.max;

    const charts = [graph1Ref.current, graph2Ref.current, graph3Ref.current]
      .filter(chart => chart && chart !== sourceChart);

    charts.forEach(chart => {
      if (chart) {
        chart.scales['x'].options.min = newMin;
        chart.scales['x'].options.max = newMax;

        if (chart.$zoom && chart.$zoom._resetZoom) {
          chart.$zoom._resetZoom();
        }

        chart.update();
      }
    });
  };

  const handleResetZoom = () => {
    if (graph1Ref.current) {
      graph1Ref.current.resetZoom();
    }
    if (graph2Ref.current) {
      graph2Ref.current.resetZoom();
    }
    if (graph3Ref.current) {
      graph3Ref.current.resetZoom();
    }
  };

  return (
    <>
      <div
        className="flex flex-col w-full"
      >
        <div
          className="flex cursor-pointer items-center mb-2 justify-between"
          onClick={toggleAccordion}
        >
          <div
            className="mr-1 text-primary text-md font-bold"
          >
            Charts
          </div>
          <div className="text-primary">
            {isOpen ? <MdExpandMore className="w-6 h-6" /> : <MdExpandLess className="w-6 h-6" />}
          </div>
        </div>
        {isOpen && (
          <>
          <div className="flex items-center bg-secondary-bg rounded-md mb-2">
              {options.map((option, index) => (
                <div
                  key={index}
                  className={`cursor-pointer w-full px-3 py-2 text-sm font-semibold text-center rounded-md ${
                    selectedOption === option
                      ? "bg-primary text-secondary"
                      : "text-primary"
                  }`}
                  onClick={() => {
                    if (option === "Reset") {
                      handleResetZoom();
                    } else {
                      if (selectedOption === option) {
                        handleResetZoom();
                      }
                      setSelectedOption(option);
                    }
                  }}
                >
                  {mapDuration(option)}
                </div>
              ))}
            </div>

            <div className="flex flex-col gap-6 lg:flex-row lg:items-stretch">
              <div className="flex-1 lg:max-w-[33%]">
                <div className="flex mt-2" ref={randomRef}>
                  {chartTypes.map((option, index) => (
                    <div key={index} className="flex items-center mb-1 mr-3 last:mr-0">
                      <div
                        className="w-8 h-1"
                        style={{
                          backgroundColor: option.color,
                          borderRadius: "2px",
                        }}
                      ></div>
                      <span
                        className="ml-1 text-white"
                        style={{ fontSize: "12px" }}
                      >
                        {option.type}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="bg-secondary-bg rounded-xl h-fit mt-2">
                  {graphData && graphData.length > 1 && (
                    <AreaChartWithCustomTooltip
                      data={graphData}
                      labels={labels}
                      hoveredIndex={hoveredIndexRef}
                      title="Stock Price"
                      valueProperty="value"
                      graph1Ref={graph1Ref}
                      onZoom={(chart) => handleZoomSync(chart)}
                      onResetZoom={handleResetZoom}
                      selectedOption={selectedOption}
                      settingsData={settingsData}
                    />
                  )}
                </div>
              </div>

              <div className="flex-1 lg:max-w-[33%]">
                <div className="flex mt-4 lg:mt-2">
                  <div className="flex items-center mb-1 mr-3">
                    <div
                      className="w-8 h-1"
                      style={{ backgroundColor: "#4ade80", borderRadius: "2px" }}
                    ></div>
                    <span
                      className="ml-1 text-white"
                      style={{ fontSize: "12px" }}
                    >
                      Seller Rank
                    </span>
                  </div>
                </div>
                <div className="bg-secondary-bg rounded-xl h-fit mt-2">
                  {graphData && graphData.length > 1 && (
                    <BsrChart
                      data={graphData}
                      labels={labels}
                      title="Stock Price"
                      valueProperty="value"
                      hoveredIndex={hoveredIndexRef}
                      atHover={handleHover}
                      onLeave={handleLeave}
                      graph2Ref={graph2Ref}
                      onZoom={(chart) => handleZoomSync(chart)}
                      onResetZoom={handleResetZoom}
                      selectedOption={selectedOption}
                    />
                  )}
                </div>
              </div>

              <div className="flex-1 lg:max-w-[33%]">
                <div className="flex mt-4 lg:mt-2">
                  {reviewChart.map((option, index) => (
                    <div key={index} className="flex items-center mb-1 mr-3 last:mr-0">
                      <div
                        className="w-8 h-1"
                        style={{
                          backgroundColor: option.color,
                          borderRadius: "2px",
                        }}
                      ></div>
                      <span
                        className="ml-1 text-white"
                        style={{ fontSize: "12px" }}
                      >
                        {option.type}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="bg-secondary-bg rounded-xl h-fit mt-2">
                  {graphData && graphData.length > 1 && (
                    <ReviewOfferChart
                      data={graphData}
                      labels={labels}
                      title="Stock Price"
                      valueProperty="value"
                      hoveredIndex={hoveredIndexRef}
                      atHover={handleHover}
                      onLeave={handleLeave}
                      graph3Ref={graph3Ref}
                      onZoom={(chart) => handleZoomSync(chart)}
                      onResetZoom={handleResetZoom}
                      selectedOption={selectedOption}
                    />
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Chart;
